import CSVParametersBuilder from '../CSVParametersBuilder'
import CSVParametersSection from '../CSVParametersSection'
import messageResource from '../../../../messageResource'
import EstimateVsActualCSVPreviewHeader from './EstimateVsActualCSVPreviewHeader'
import EstimateVsActualCSVPreviewGroupingSection from './EstimateVsActualCSVPreviewGroupingSection'
import AllTasksEvACSVPreviewColumnStrategy from './AllTasksEvACSVPreviewColumnStrategy'
import TasksWithEstimatesEvACSVPreviewColumnStrategy from './TasksWithEstimatesEvACSVPreviewColumnStrategy'

export default function EstimateVsActualCSVPreviewGenerator() {}

EstimateVsActualCSVPreviewGenerator.prototype.init = function(){
    return this;
};

EstimateVsActualCSVPreviewGenerator.prototype.generatePreviewTable = function( reportParameters, reportParamsStringBuilder) 
{
    const taskParams = {
        tasksConfig: reportParameters.tasksConfig,
        includeNotEstimated: !!reportParameters.includeNotEstimated,
        includeNotStarted: !!reportParameters.includeNotStarted
    }

    const groupingLevelsArray = [
        reportParameters.firstGroupingLevel,
        reportParameters.secondGroupingLevel,
        reportParameters.thirdGroupingLevel,
        reportParameters.fourthGroupingLevel
    ]

    const filteredLevelsArray = ReportPreviewUtils.filterNotEmptyLevels(groupingLevelsArray)

    const table = document.createElement("table")
    table.className = "reportCsvPreviewTable eva";
    const tBody = document.createElement("tbody")
    table.appendChild( tBody );

    const columnsStrategy = this.createPreviewStrategy(taskParams)
    const totalColumnsNum = filteredLevelsArray.length + 4 + columnsStrategy.getNumOfDataColumns() // total spent, est time, variance mh, variance %

    ReportPreviewUtils.addSheetHeaderRow( tBody, totalColumnsNum );

    const header = new EstimateVsActualCSVPreviewHeader().init(filteredLevelsArray, columnsStrategy)

    const reportAuthorizationInfo = reportParameters.reportAuthorizationInfo
    const dataGroupingSection = new EstimateVsActualCSVPreviewGroupingSection().init(filteredLevelsArray, columnsStrategy, reportAuthorizationInfo)
    const paramsBuilder = new CSVParametersBuilder().init()
    
    paramsBuilder.addCPParam( reportParameters.customersProjectsSelection, reportParamsStringBuilder );
    paramsBuilder.addEvATasksParam( taskParams, reportParameters.dateSelection, reportParamsStringBuilder );
    this.addDateParam( paramsBuilder, reportParameters.dateSelection, reportParamsStringBuilder );

    const parametersSection = new CSVParametersSection().init( paramsBuilder, totalColumnsNum )

    parametersSection.addRows( tBody );
    header.addRows( tBody );
    dataGroupingSection.addRows( tBody );

    return table;
};

EstimateVsActualCSVPreviewGenerator.prototype.addDateParam = function(paramsBuilder, dateSelection, reportParamsStringBuilder) {
    paramsBuilder.parameters.push(
        [
            messageResource.getMessage("report.budgeted_vs_actual.date_label"),
            reportParamsStringBuilder.getEvaDateCSVString(dateSelection)
        ]
    )
}

EstimateVsActualCSVPreviewGenerator.prototype.createPreviewStrategy = function ( taskParams )
{
    if ( taskParams.includeNotEstimated )
        return new AllTasksEvACSVPreviewColumnStrategy();

    return new TasksWithEstimatesEvACSVPreviewColumnStrategy();
};





// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/eva/EstimateVsActualCSVPreviewGenerator.js